import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, history } from "../Core/Store";
import { defaultDateStrings } from "../Common/Constants";
import { startAppListening } from "../Core/listenerMiddleware";
import { isEqual, update } from "lodash";
import { push } from "react-router-redux";

export interface IJiraParamSliceState {
  start: string;
  end: string;
  searchAll: string;
}
const getInitialFilters = () => {
  return {
    start: defaultDateStrings.start,
    end: defaultDateStrings.jiraEnd,
    searchAll: null,
  };
};
const initialState: any = getInitialFilters();

export const updateJiraParams2 = createAsyncThunk(
  "params/updateJiraParams",
  async (jiraParams: IJiraParamSliceState, thunkAPI: any) => {
    const path = thunkAPI.getState().router.location.pathname;

    if (!isEqual(thunkAPI.getState().params, jiraParams)) {
      thunkAPI.dispatch(push(path, jiraParams));
    }
    return jiraParams;
  }
);

const jiraParamSlice = createSlice({
  name: "jiraParams",
  initialState,
  reducers: {
    updateJiraParams: (state, action: PayloadAction<any>) => {
      if (action.payload === null) {
        return initialState;
      }
      return action.payload;
    },
  },
  //,
  //extraReducers(builder) {
  //    builder.addCase(updateJiraParams.fulfilled, (state, action) => {
  //        return action.payload;
  //    });
  //},
});

export const { updateJiraParams } = jiraParamSlice.actions;

export const getJiraParamsSelector = (state: RootState) => state.jiraParams;

export default jiraParamSlice.reducer;

//startAppListening({
//  predicate: (action, currentState: any, previousState: any) => {
//    return currentState.params !== previousState.params;
//  },
//  effect: (action, listenerApi) => {
//    listenerApi.dispatch<any>(updateSelectedDate({ selectedDate: null }));

//    //
//    // if(listenerApi.getState().router.location.pathname === "/alarms"){
//    //   listenerApi.dispatch<any>(fetchAlarmDatas(action.payload))
//    //   listenerApi.dispatch<any>(fetchAlarmDatasWithScope(action.payload))
//    //   listenerApi.dispatch<any>(fetchMachineTimes(action.payload))
//    // }
//    // if(listenerApi.getState().router.location.pathname === "/runningperiodcount"){
//    //   listenerApi.dispatch<any>(fetchVeryShortCount(action.payload))
//    // }
//    // if(listenerApi.getState().router.location.pathname === "/machinetimes"){
//    //   listenerApi.dispatch<any>(fetchMachineTimes(action.payload))
//    //   listenerApi.dispatch<any>(fetchAlarmDatasWithScope(action.payload))
//    // }
//  },
//});
